import { apiRequest } from './client';
import type { AlertRepository } from '../../application/ports/AlertRepository';
import type { Alert, AlertCondition } from '../../domain/Alert';

export class HttpAlertRepository implements AlertRepository {
  list() {
    return apiRequest<{ alerts: Alert[] }>('/alerts');
  }

  create(input: { deviceId: string; name?: string | null; conditions: AlertCondition[] }) {
    return apiRequest<{ alert: Alert }>('/alerts', { method: 'POST', body: JSON.stringify(input) });
  }

  update(id: string, input: Partial<{ enabled: boolean; name: string | null; conditions: AlertCondition[] }>) {
    return apiRequest<{ alert: Alert }>(`/alerts/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
  }

  delete(id: string) {
    return apiRequest<void>(`/alerts/${id}`, { method: 'DELETE' });
  }
}
